import { useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';
import { districtRequiresTestScores } from '../data upload/utilityFunctions';

const useDistrictRequiresTestScores = () => {
  const { schoolsConfig } = useContext(GlobalStateContext);

  return {
    requiresTestScores: districtRequiresTestScores(schoolsConfig.data ?? []),
    isPending: schoolsConfig.isPending,
    error: schoolsConfig.error,
  };
};

export default useDistrictRequiresTestScores;
